import { ApiShopperLandingPage } from '@storefronts/common-types'
import Script from 'next/script'

export const PinterestPixel: React.FC<{
    landingPage: ApiShopperLandingPage
}> = ({ landingPage }) => {
    if (!landingPage.integrations.pinterestTagId) return null

    return (
        <Script id="pinterest-pixel" strategy="afterInteractive">
            {`
                !function(e){if(!window.pintrk){window.pintrk=function(){window.pintrk.queue.push(
                Array.prototype.slice.call(arguments))};var n=window.pintrk;n.queue=[],n.version="3.0";var t=document.createElement("script");t.async=!0,t.src=e;var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
                pintrk('load', '${landingPage.integrations.pinterestTagId}');
                pintrk('page');
            `}
        </Script>
    )
}
